import React, {useState} from 'react'
import {Box} from '../../webui/Box'
import {Button} from '../../webui/Button'
import {Container} from '../../webui/Container'
import {Paper} from '../../webui/Paper'
import {Typography} from '../../webui/Typography'
import {CompartmentsThatNeedsAction} from './CompartmentsThatNeedsAction'
import {NotStoppedRentals} from './NotStoppedRentals'
import {RentalActionsTableWithSearch} from './RentalActionsTableWithSearch'
import {UnpaidRentals} from './UnpaidRentals'
import {FailedOpeningsTable} from './FailedOpeningsTable'

interface Props {}

export const ActionsPage: React.FC<Props> = () => {
  const [showUnpaidRentals, setShowUnpaidRentals] = useState(false)
  const [showNotStoppedRentals, setShowNotStoppedRentals] = useState(false)

  const onToggleShowUnpaidRentals = () => {
    setShowUnpaidRentals((prevState) => !prevState)
  }
  const onToggleShowNotStoppedRentals = () => {
    setShowNotStoppedRentals((prevState) => !prevState)
  }

  return (
    <Box>
      <Paper>
        {/* NOTE: Deliberately NOT using <Container> here.
            Container centers content and constrains width, which prevents the
            "table + map side-by-side" layout from using available screen space. */}
        <Box px={{xs: 1, sm: 2}} py={2}>
          <CompartmentsThatNeedsAction />
        </Box>
      </Paper>

      <Box pt={2}>
        <Paper>
          <Container>
            <Box px={{xs: 1, sm: 2}} py={2}>
              <Typography variant="h3" id="heading-over-table">
                Failed openings past two weeks
              </Typography>
              <FailedOpeningsTable />
            </Box>
          </Container>
        </Paper>
      </Box>

      <Box pt={2}>
        <Paper>
          <Box pl={2} pt={3}>
            <Typography variant="h3" id="heading-over-table">
              Rentals that may need action
            </Typography>
          </Box>
          <RentalActionsTableWithSearch />
        </Paper>
      </Box>

      <Box mt={2}>
        <Paper>
          <Box display={'flex'} p={2} justifyContent={'center'}>
            <Button onClick={onToggleShowNotStoppedRentals}>{showNotStoppedRentals ? 'Hide not stopped rentals' : 'Show not stopped rentals'}</Button>
          </Box>
          {showNotStoppedRentals && (
            <Container>
              <Box pt={1} pb={1}>
                <Typography variant="h6">Not stopped rentals</Typography>
                <NotStoppedRentals />
              </Box>
            </Container>
          )}
        </Paper>
      </Box>

      <Box mt={2}>
        <Paper>
          <Box display={'flex'} p={2} justifyContent={'center'}>
            <Button onClick={onToggleShowUnpaidRentals}>{showUnpaidRentals ? 'Hide unpaid rentals' : 'Show unpaid rentals'}</Button>
          </Box>
          {showUnpaidRentals && (
            <Container>
              <UnpaidRentals />
            </Container>
          )}
        </Paper>
      </Box>
    </Box>
  )
}
